<style>
  td{
    vertical-align: baseline !important;
    padding-bottom: 10 px;
    max-width: auto;
  }
  td:first-child{
    padding-right: 5px;
    min-width: 60px;
  }
  th{
    width: 8em;
  }

  .custom-{
    max-width: 90% !important;
  }
  .error{
    text-align:center;
  }
</style>
<form class="form-validation">
  <div class="modal-header bg-primary text-light">
    <h4 class="modal-title">Dimension Details</h4>
  </div>

  <div class="modal-body">
    <div class="row center">
      <div class="col">
        <label for="numberOfFloors" class="form-label">Number of floors</label>
        <select
          class="form-select mb-3"
          [ngModelOptions]="{ standalone: true }"
          id="numberOfFloors"
          (change)="adjustBuildingDimensions()"
          [(ngModel)]="numberOfFloors"
          [disabled]="!isEdit"
        >
          <option *ngFor="let option of numberOfFloorsOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <table class="simple">
          <thead>
            <tr>
              <th>Floor</th>
              <th>Area (m<sup>2</sup>)</th>
              <th>Room height (m)</th>
              <th>Heat loss perimeter (m)</th>
              <th *ngIf="!partyWallConstructionNotApplicable">
                Party wall length (m)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let bdMainBuildingDetail of buildingDimensionDetails; let i = index">
              <td>{{ setTitles(i) }}</td>
              <td>
                <input
                  class="form-control"
                  type="number"
                  min="1"
                  max="999"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="bdMainBuildingDetail.area"
                  name="area"
                  #area="ngModel"
                  required
                  style="min-width:60px;"
                />
                <div *ngIf="area.invalid && (area.dirty || area.touched || showErrors)" class="error mt-1" style="color: red; font-size: 0.9em;">
                  <div *ngIf="area.errors?.min">
                    Floor area should be greater than 0.
                  </div>
                  <div *ngIf="area.errors?.max">
                    Floor area should be less than or equal to 999.
                  </div>
                  <div *ngIf="area.errors?.required">
                    Floor area is required.
                  </div>
                </div>
              </td>
              
              
              <td>
                <input
                  class="form-control"
                  type="number"
                  min="1"
                  max="9"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="bdMainBuildingDetail.height"
                  required
                  name="height"
                  #height="ngModel"
                />
                <div *ngIf="height.invalid && (height.dirty || height.touched || showErrors)" class="error mt-1" style="color: red; font-size: 0.9em;">
                  <div *ngIf="height.errors?.min">
                    Room height should be greater than 0.
                  </div>
                  <div *ngIf="height.errors?.max">
                    Room height should be less than or equal to 9.
                  </div>
                  <div *ngIf="height.errors?.required">
                    Room height is required.
                  </div>
                </div>
              </td>
              <td>
                <input
                  class="form-control"
                  type="number"
                  min="1"
                  max="999"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="bdMainBuildingDetail.perimeter"
                  required
                  name="perimeter"
                  #perimeter="ngModel"
                  style="min-width: 60px;"
                />
                <div *ngIf="perimeter.invalid && (perimeter.dirty || perimeter.touched || showErrors)" class="error mt-1" style="color: red; font-size: 0.9em;">
                  <div *ngIf="perimeter.errors?.min">
                    Perimeter should be greater than 0.
                  </div>
                  <div *ngIf="perimeter.errors?.max">
                    Perimeter should be less than or equal to 9.
                  </div>
                  <div *ngIf="perimeter.errors?.required">
                    Perimeter value is required.
                  </div>
                </div>
              </td>
              <td *ngIf="!partyWallConstructionNotApplicable && ((heatedBasement && i != 0) || (!heatedBasement))">
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  max="999"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="bdMainBuildingDetail.partyWall"
                  required
                  name="partyWall"
                  #partyWall="ngModel"
                  style="min-width: 60px;"
                />
                <div *ngIf="partyWall.invalid && (partyWall.dirty || partyWall.touched || showErrors)" class="error mt-1" style="color: red; font-size: 0.9em;">
                  <div *ngIf="partyWall.errors?.min">
                    Party wall length should be greater than 0.
                  </div>
                  <div *ngIf="partyWall.errors?.max">
                    Party wall length should be less than or equal to 9.
                  </div>
                  <div *ngIf="partyWall.errors?.required">
                    Party wall length value is required.
                  </div>
                </div>
                
              </td>
              <td *ngIf="((heatedBasement && i != 0) || (!heatedBasement))"><button type="button" *ngIf="isEdit" (click)="copyFloor(i)" class="btn btn-primary">Copy</button></td>
              
            </tr>
          </tbody>
        </table>
        <p
          *ngIf="!dimensionForm?.invalid && partyWallLengthMissing()"
          class="bold-text red-fg"
        >
          Party wall length should be at least 1 for at least 1 building part.
        </p>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">
      Close
    </button>
  </div>
</form>
